export default "__VITE_ASSET__CqdLrKWp__"